var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-login d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"w-100"},[_c('login-with-google',{attrs:{"label":_vm.googleLabel},on:{"on-success":_vm.onSuccess}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }